module.exports = __webpack_public_path__ + "img/minikube.b39dc584.svg";